import { apiFetch, type ApiFetchOptions } from '~/utils/apiFetch'
import {
  NOTIFICATIONS_PAGE_SIZE,
  type ListNotificationsQuery,
  type MarkAllNotificationsReadRequestDto,
  type NotificationDetailDto,
  type NotificationListDto,
  type NotificationReadResultDto,
} from '~/types/api/notice'

/** GET /api/v1/notifications — 站内信列表（个人消息与广播已合并） */
export function listNotifications(query?: ListNotificationsQuery) {
  return apiFetch<NotificationListDto>('/notifications', {
    query: {
      category: 'all',
      page_size: NOTIFICATIONS_PAGE_SIZE,
      ...query,
    },
  })
}

/**
 * GET /api/v1/notifications/{msg_id} — 站内信详情
 * msg_id 取列表原样回传。只读，不会标已读；打开详情后再调 markNotificationRead。
 * 不属于当前玩家、已撤回或超出保留窗口统一 404。
 */
export function fetchNotificationDetail(msgId: string, options?: ApiFetchOptions) {
  return apiFetch<NotificationDetailDto>(`/notifications/${encodeURIComponent(msgId)}`, options)
}

/** POST /api/v1/notifications/{msg_id}/read — 单条标为已读（幂等，不挡全屏 loading） */
export function markNotificationRead(msgId: string) {
  return apiFetch<NotificationReadResultDto>(`/notifications/${encodeURIComponent(msgId)}/read`, {
    method: 'POST',
    skipGlobalLoading: true,
  })
}

/** POST /api/v1/notifications/read-all — 全部已读（可按页签） */
export function markAllNotificationsRead(body?: MarkAllNotificationsReadRequestDto) {
  return apiFetch<NotificationReadResultDto>('/notifications/read-all', {
    method: 'POST',
    body: body ?? {},
  })
}
